import * as actionTypes from './actionTypes';

import scriptCache from 'Flow2/util/ScriptCache';
import { authCheckState } from './auth';

export const initStart = () => {
    return {
        type: actionTypes.INIT_START
    };
};

export const initSuccess = () => {
    return {
        type: actionTypes.INIT_SUCCESS,
    };
};

export const initFail = (error) => {
    return {
        type: actionTypes.INIT_FAIL,
        error: error
    };
};

export const applicationError = (error) => {
    return {
        type: actionTypes.APP_ERROR,
        error: error
    };
};

const delay = (d) => {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            resolve();
        }, d);
    });
};
const envUrl = (s) => {
    return s.replace('%protocol%', window.location.protocol)
        .replace('%hostname%', window.location.hostname)
        .replace('%port%', window.location.port);
};

const libLoaded = () => {
    return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined') {
            window.flow = new window.felib.main(envUrl(process.env.REACT_APP_FELIB_APIURL), { pingtime: 60 });
            //LAMTEST BEGIN
            // window.flow.addEventListener(window.felib.main.event.LOGOUT, (ev) => {
            //     console.log('LAMTEST01 Logout: ', ev.message);
            // });
            //LAMTEST END
            resolve(window.flow);
        } else {
            return reject('no lib');
        }
    });
};

export const init = () => {
    console.log(process.env.REACT_APP_FELIB_SCRIPTURL);
    return dispatch => {
        dispatch(initStart());
        let cache = scriptCache({ felib: envUrl(process.env.REACT_APP_FELIB_SCRIPTURL) });

        cache.felib.onLoad(() => {
            libLoaded()
                .then((flow) => {
                    flow.init();
                    dispatch(initSuccess());
                    dispatch(authCheckState());
                })
                .catch(() => dispatch(initFail()));
        });
    };
};

export const addMessage = (label, text = '', type = 'text', target = 'both') => {
    return {
        type: actionTypes.APP_ADD_MESSAGE,
        payload: {
            message: {
                elementType: type,
                label: label,
                text: text
            },
            target: target
        }
    };

}

export const removeDialog = () => {
    return {
        type: actionTypes.APP_REMOVE_DIALOG
    }
}
